import { render, staticRenderFns } from "./MyMusic.vue?vue&type=template&id=09a6db2f&scoped=true"
import script from "./MyMusic.vue?vue&type=script&lang=js"
export * from "./MyMusic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a6db2f",
  null
  
)

export default component.exports